<template>
    <a :href='cardData.url' target="_blank">
        <Card class="my-card" style="width:295px">
            <Row>
                <Col span="6">
                <img class="my-card-logo" :src="cardData.imgUrl">
                </Col>
                <Col span="18">
                <h4>{{cardData.name}}</h4>
                <p>{{cardData.des.length>13?cardData.des.substr(0,12)+'...':cardData.des}}</p>
                </Col>
            </Row>
        </Card>
    </a>
</template>
<style>
    .my-card {
        cursor: pointer;
        display: inline-block;
        margin: 0 5px 5px 0;
    }

    .my-card-logo {
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }
</style>
<script>
    export default {
        props: ['cardData']
    }

</script>


// WEBPACK FOOTER //
// card.vue?24f79eac